export class TechCoverContact {
  famCode: string;
  email: string;
  phone?: string;
}
